var _defs, _circle, _path, _rect, _rect2, _polygon, _path2, _path3, _path4, _polygon2, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVertacxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 222 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 189.9,
    y1: 65.2,
    x2: 189.9,
    y2: 18.61,
    gradientTransform: "translate(0 147.36) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c753f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a136f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 186.16,
    y1: 65.2,
    x2: 186.16,
    y2: 18.61,
    xlinkHref: "#linear-gradient"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 111,
    cy: 111,
    r: 111
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.79,121.2l-2.83-3.7-7.4,10.3h6.31l4.26-6.15-.34-.45Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186.9,
    y: 93.67,
    width: 6,
    height: 13.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 179.42,
    y: 93.67,
    width: 13.48,
    height: 6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "174.74 116.14 182.89 104.56 176.58 104.56 171.7 111.83 171.25 112.63 165.46 104.56 159.7 104.56 174.3 124.51 175.09 125.55 175.74 126.41 175.76 126.44 176.71 127.8 183.02 127.8 174.74 116.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.16,119.64c-.03.12-.1.38-.21.79l-.26.75-.48-1.53-4.96-15.13h-6.15l8.69,23.77h5.53l8.95-23.77h-6.06l-5.04,15.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.23,109.64c-1.26-1.84-2.78-3.16-4.56-3.97-1.62-.77-3.38-1.18-5.17-1.21-4.93.01-9.35,3.04-11.14,7.63-.51,1.34-.78,2.77-.79,4.21,0,2.4.73,4.74,2.1,6.71,1.26,1.87,2.77,3.21,4.54,4.01,1.63.77,3.4,1.18,5.2,1.21,1.99,0,3.95-.49,5.7-1.45,1.74-.93,3.22-2.29,4.3-3.95l-4.78-1.84c-.64.74-1.45,1.32-2.35,1.7-.91.39-1.88.59-2.87.59-.84,0-1.67-.14-2.45-.44-.93-.35-1.77-.89-2.46-1.61-.7-.72-1.24-1.58-1.58-2.52l18.16-.49v-.04l.09.04c.09-.62.13-1.26.13-1.89,0-2.39-.72-4.73-2.06-6.71ZM58.87,114.16l.09-.26c.49-1.33,1.4-2.47,2.59-3.24,1.17-.78,2.54-1.19,3.95-1.18,1.83-.01,3.59.71,4.89,1.99.68.67,1.19,1.49,1.51,2.39l-13.03.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.37,105.74c-1.82,1-3.34,2.46-4.41,4.24-1.06,1.74-1.61,3.73-1.6,5.77l.04,12.59h5.13l-.09-11.79c-.02-1.22.32-2.43.97-3.47.61-1.05,1.47-1.91,2.52-2.52,1.04-.62,2.23-.95,3.44-.94.15,0,.48.03,1.01.09v-5.4l-1.14-.09c-2.06-.01-4.08.52-5.87,1.53Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "103.08 96.14 97.33 96.14 97.33 128.15 103.08 128.15 103.08 108.37 106.98 108.37 108.34 103.29 103.08 103.29 103.08 96.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.92,110.18c-1.07-1.75-2.57-3.19-4.36-4.19-1.79-1.03-3.83-1.57-5.9-1.56-2.08-.02-4.12.52-5.91,1.57-1.81,1.05-3.31,2.55-4.36,4.36-1.06,1.8-1.61,3.85-1.6,5.93-.02,2.09.54,4.14,1.62,5.92,3.24,5.67,10.46,7.65,16.13,4.41.37-.21.72-.44,1.06-.68v2.1h4.91l.04-12.1c0-2.04-.56-4.04-1.63-5.77ZM126.67,119.78c-.63,1.04-1.51,1.91-2.56,2.52-1.04.62-2.23.95-3.44.94-1.22.02-2.43-.32-3.46-.96-1.05-.61-1.91-1.47-2.52-2.52-.62-1.04-.95-2.23-.94-3.44-.02-1.22.32-2.43.97-3.46.61-1.05,1.47-1.91,2.52-2.52,1.04-.62,2.23-.95,3.44-.94,1.22-.01,2.41.31,3.47.92,1.04.63,1.91,1.51,2.52,2.56,1.25,2.13,1.26,4.77.02,6.91h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.47,122.03c-1.16.83-2.55,1.26-3.97,1.25-1.22.02-2.43-.32-3.47-.96-1.05-.61-1.92-1.48-2.52-2.52-.62-1.04-.95-2.23-.94-3.44-.02-1.22.32-2.43.97-3.47.61-1.04,1.48-1.91,2.52-2.52,2.31-1.35,5.19-1.24,7.39.28,1.15.78,2.02,1.9,2.51,3.2l5.18.04c-.38-1.75-1.15-3.4-2.24-4.82-1.12-1.42-2.55-2.57-4.16-3.38-3.54-1.75-7.72-1.62-11.14.35-1.81,1.05-3.32,2.55-4.38,4.36-1.06,1.8-1.61,3.85-1.6,5.93-.02,2.09.54,4.14,1.62,5.92,2.1,3.69,6.02,5.97,10.26,5.96,1.83.02,3.63-.4,5.26-1.23,3.26-1.62,5.6-4.64,6.36-8.2h-5.13c-.49,1.31-1.37,2.44-2.52,3.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertacxLogo);
export default __webpack_public_path__ + "static/media/Vertacx-logo.eac43704bce9615ee2a66f4a153175d4.svg";
export { ForwardRef as ReactComponent };